/** Mirror ``guardiansv2.prompts._render`` — literal ``{key}`` substitution only. */
export function renderPromptTemplate(
  template: string,
  context: Record<string, string>
): string {
  let result = template;
  for (const [key, value] of Object.entries(context)) {
    result = result.split(`{${key}}`).join(value ?? "");
  }
  return result;
}
